import { Controller } from '@hotwired/stimulus'

export default class NoteFormController extends Controller {
  static targets = ['fileInput', 'filePlaceholder']

  showFilename() {
    this.filePlaceholderTarget.classList.remove('d-none')
    this.filePlaceholderTarget.innerText = this.fileInputTarget.files[0].name
  }
}
